import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../../constants/text';
import { safeGet } from '../../../../../../../core/util/object';
import { getInsuranceCarrierCardDisplayProperties } from '../../../../../../../core/util/insurance';
import InsurerPhone from '../../InsuranceCard/components/CarrierContactInfo/InsurerPhone';
import { COPAY_MODAL_CALL_INSURANCE_CARRIER } from '../../../../../../../core/analytics/events';

const Root = styled.div.withConfig({ componentId: 'sc-11bunt4-0' })`
  background-color: ${colors.theWhiteAlbum};
  padding: 25px 30px;
  box-shadow: inset 0 1px 0 0 ${colors.emptyBarGrey}, inset 0 -1px 0 0 ${colors.emptyBarGrey};
  border-bottom: 1px solid ${colors.granite};
`;

const Description = styled.div.withConfig({ componentId: 'sc-11bunt4-1' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: 0.25px;
  color: ${colors.blueMonday};
  line-height: 20px;
  padding-bottom: 10px;
`;

const PhoneLogoContainer = styled.div.withConfig({ componentId: 'sc-11bunt4-2' })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px auto;
  color: ${colors.blueJayWay};
`;

const Logo = styled.img.withConfig({ componentId: 'sc-11bunt4-3' })`
  width: 120px;
`;

const Phone = styled(InsurerPhone).withConfig({ componentId: 'sc-11bunt4-4' })`
  color: ${colors.blueMonday} !important;
`;

type Props = {
  insuranceProfile?: any;
};

const CarrierContactInfo = (props: Props) => {
  const { insuranceProfile } = props;
  const insuranceCarrierDisplayProperties = getInsuranceCarrierCardDisplayProperties(
    insuranceProfile.insurer_code
  );
  return (
    <Root>
      <Description>
        {/* @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'. */}
        Call {insuranceCarrierDisplayProperties.displayName} with any questions about in- and
        out-of-network providers, costs, or covered services.
      </Description>

      <PhoneLogoContainer>
        <Phone
          insuranceCarrierDisplayProperties={insuranceCarrierDisplayProperties}
          // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
          insuranceCarrierName={insuranceCarrierDisplayProperties.displayName}
          insurerCode={insuranceProfile.insurer_code}
          insurerPhone={safeGet(insuranceCarrierDisplayProperties)('phoneNumber')}
          insurerType={insuranceProfile.insurer_type}
          trackingCode={COPAY_MODAL_CALL_INSURANCE_CARRIER}
        />
        {/* @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'. */}
        <Logo src={insuranceCarrierDisplayProperties.logo} />
      </PhoneLogoContainer>
    </Root>
  );
};

export default CarrierContactInfo;
